
import { GenericEntityBase, KeyType } from "../../_models/GenericEntityBase";
import { IPropretyAttribute, IEntityMetaData } from "../../_models/IEntityMetaData";
import { PropretyAttributes, Validation, NestedProperty, NavigationProperty } from "../../decorators/EntityDecorators";
import { PointOfService } from "./PointOfService.model";
import { EngagementTranslation } from "./EngagementTranslation.model";
import { Translation } from "./navigation-entities/Translation.model";

export class Engagement extends GenericEntityBase<number> {
  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.KeyProperty,
      IPropretyAttribute.Readonly
    ]
  })
  id: number = GenericEntityBase.GetDefaultId(KeyType.number);

  Description?: string;

  Numero?: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  fK_PointOfService!: number;

  @NestedProperty({ TargetType: PointOfService })
  pointOfService?: PointOfService;

  // @NavigationProperty({ TargetType: EngagementTranslation })
  // engagementTranslations?: EngagementTranslation[];

  @NavigationProperty({ TargetType: Translation })
  translations?: Translation[];

  GetType(): IEntityMetaData {
    return Engagement.getMetaData();
  }
}
